module.exports = __webpack_public_path__ + "img/book.d79544e1.svg";